export enum LgpdMaskingType {
    CPF,
    CNPJ,
    NAME,
}
